(() => {
  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || "USD";
    const locale = window.Shopify?.locale || "en-US";
    const amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency }).format(amount);
    } catch {
      return `$${amount.toFixed(2)}`;
    }
  }

  // Find the product variants array anywhere on the page (robust across Dawn variants)
  function findVariantsArray(scope = document) {
    // 1) Scan all JSON scripts in the closest product section first
    const section =
      scope.closest?.(".shopify-section") ||
      scope.closest?.("section") ||
      document;

    const scripts = Array.from(section.querySelectorAll('script[type="application/json"]'))
      .concat(Array.from(document.querySelectorAll('script[type="application/json"]')));

    for (const s of scripts) {
      let parsed;
      try {
        parsed = JSON.parse(s.textContent);
      } catch {
        continue;
      }

      // If it's an object that *contains* variants array
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        // common keys
        const maybe = parsed.variants || parsed.product?.variants;
        if (Array.isArray(maybe) && maybe.length && maybe[0]?.id != null && maybe[0]?.price != null) {
          return maybe;
        }
      }

      // If it's directly the variants array
      if (Array.isArray(parsed) && parsed.length) {
        const first = parsed[0];
        if (first && typeof first === "object" && first.id != null && first.price != null) {
          return parsed;
        }
      }
    }

    // 2) Shopify analytics meta fallback (sometimes present)
    const meta = window.ShopifyAnalytics?.meta?.product?.variants;
    if (Array.isArray(meta) && meta.length && meta[0]?.id != null && meta[0]?.price != null) {
      return meta;
    }

    return null;
  }

  function getOptionPosition(select) {
    const wrapper = select.closest("[data-option-position]");
    if (wrapper?.dataset?.optionPosition) return Number(wrapper.dataset.optionPosition);

    // Fallback: order among selects in the picker
    const picker = select.closest("variant-selects, variant-radios, .product") || document;
    const all = Array.from(picker.querySelectorAll("select"));
    const idx = all.indexOf(select);
    return idx >= 0 ? idx + 1 : 1;
  }

  function optionAt(v, pos) {
    if (pos === 1) return v.option1;
    if (pos === 2) return v.option2;
    if (pos === 3) return v.option3;
    return null;
  }

  function uniquePricesForValue(variants, optionPos, value) {
    const prices = new Set();
    for (const v of variants) {
      const opt = optionAt(v, optionPos);
      if (String(opt) === String(value)) {
        prices.add(v.price);
        if (prices.size > 1) break;
      }
    }
    return prices;
  }

  // Show prices ONLY if:
  // - each value maps to exactly 1 unique price (safe)
  // - and there is more than one distinct price overall (otherwise hide)
  function shouldShow(select, variants, optionPos) {
    const overall = new Set();

    for (const opt of select.options) {
      if (!opt.value) continue; // placeholder
      const prices = uniquePricesForValue(variants, optionPos, opt.value);
      if (prices.size !== 1) return false; // depends on other selections -> don't label
      overall.add(Array.from(prices)[0]);
    }

    return overall.size > 1;
  }

  function labelSelect(select, variants) {
    const optionPos = getOptionPosition(select);

    // store original labels once
    for (const opt of select.options) {
      if (!opt.dataset.originalText) opt.dataset.originalText = opt.textContent.trim();
    }

    const show = shouldShow(select, variants, optionPos);

    for (const opt of select.options) {
      if (!opt.value) continue;
      const base = opt.dataset.originalText || opt.textContent.trim();

      if (!show) {
        opt.textContent = base;
        continue;
      }

      const prices = uniquePricesForValue(variants, optionPos, opt.value);
      if (prices.size === 1) {
        const p = Array.from(prices)[0];
        opt.textContent = `${base} — ${formatMoney(p)}`;
      } else {
        opt.textContent = base;
      }
    }
  }

  function run() {
    const pickers = document.querySelectorAll("variant-selects, variant-radios");
    if (!pickers.length) return;

    for (const picker of pickers) {
      const variants = findVariantsArray(picker);
      if (!variants) continue;

      const selects = picker.querySelectorAll("select");
      selects.forEach((sel) => labelSelect(sel, variants));
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Re-run when sections re-render
  document.addEventListener("shopify:section:load", run);
})();
